import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import {
  VoxAddressSearchModule,
  VoxPhoneTextFieldModule,
  VoxPasswordComponentModule,
  VoxQuantitySelectModule,
} from "ng-voxloud";

import { TranslateModule } from "@ngx-translate/core";
import { LaddaModule } from "angular2-ladda";

import { SalesRoutingModule } from "./sales-routing.module";
import {
  LeadComponent,
  TrustpilotReviewComponent,
  SendSmsComponent,
  TrialLinkMainComponent,
  TrialLinkVoiceComponent,
  TrialLinkFormComponent,
  ActivationLinkMainComponent,
  ActivationLinkPlansComponent,
  ActivationLinkFormComponent,
  ActivationLinkNewPlansComponent,
  DealIdExplainationPopupComponent,
  ActivationLinkAddonSelectorComponent,
  ActivationLinkAddonCardComponent,
  ActivationLinkUnlimitedVoiceComponent,
  ActivationLinkSetupFeeComponent,
} from "./components";
import {
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { SharedModule } from "src/app/shared/shared.module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

@NgModule({
  declarations: [
    LeadComponent,
    TrustpilotReviewComponent,
    SendSmsComponent,
    DealIdExplainationPopupComponent,
    TrialLinkMainComponent,
    TrialLinkVoiceComponent,
    TrialLinkFormComponent,
    ActivationLinkMainComponent,
    ActivationLinkPlansComponent,
    ActivationLinkFormComponent,
    ActivationLinkNewPlansComponent,
    ActivationLinkAddonCardComponent,
    ActivationLinkAddonSelectorComponent,
    ActivationLinkUnlimitedVoiceComponent,
    ActivationLinkSetupFeeComponent,
  ],
  imports: [
    SalesRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbTooltipModule,
    NgxSkeletonLoaderModule,
    VoxAddressSearchModule,
    VoxPhoneTextFieldModule,
    VoxQuantitySelectModule,
    VoxPasswordComponentModule,
    TranslateModule.forChild(),
    LaddaModule.forRoot({
      spinnerColor: "grey",
      style: "zoom-in",
    }),
    SharedModule,
    NgbNavModule,
  ],
})
export class SalesModule {}
